import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import axiosUsers from "../../services/axios/users";

// Megaphone SVG Icon
export default function Announcements({
  currentUser,
}: {
  currentUser: { readAnnouncementsDate: string; uid: string } | undefined;
}) {
  const [showAnnouncements, setShowAnnouncements] = useState(false);
  const announcementsQuery = useQuery<{
    announcements: Array<{
      title: string;
      content: string;
      date: string;
      image?: string;
    }>;
  }>({
    queryKey: ["announcement"],
    staleTime: 60 * 60 * 1000,
    enabled: currentUser != null,
  });
  const announcements = announcementsQuery.data?.announcements ?? [];
  let newCount = announcements.length;
  if (announcements.length > 0 && currentUser?.readAnnouncementsDate) {
    const readDate = new Date(currentUser.readAnnouncementsDate);
    newCount = announcements.filter((a) => new Date(a.date) > readDate).length;
  }
  return (
    <div className={`relative flex items-center mx-4 `}>
      <button
        className={`focus:outline-none pr-4 ${announcements.length > 0 ? "" : "opacity-40"}`}
        onClick={() => {
          if (!currentUser?.uid) {
            return;
          }
          if (showAnnouncements) {
            setShowAnnouncements(false);
          } else {
            setShowAnnouncements(true);
            axiosUsers.updateUserById({
              uid: currentUser!.uid,
              readAnnouncementsDate: new Date(),
            });
          }
        }}
        aria-label="Show announcements"
        disabled={announcements.length < 1}
      >
        <svg
          width="91.148"
          height="80.828"
          version="1.1"
          viewBox="0 0 91.148 80.828"
          xmlns="http://www.w3.org/2000/svg"
          className="w-6 h-6 text-snow-white"
        >
          <path
            d="m74.429 1.7312e-4c-0.99847-0.0094-1.9992 0.36518-2.7715 1.123l-9.8301 9.6445c-1.5446 1.5157-1.5665 3.9789-0.05078 5.5234 1.5157 1.5446 3.9789 1.5685 5.5234 0.05273l9.8281-9.6445c1.5446-1.5157 1.5685-3.9808 0.05273-5.5254-0.75786-0.77229-1.7535-1.1644-2.752-1.1738zm-20.404 0.50977-38.352 27.834 7.5 28 47.535 4.9453zm33.025 18.621c-0.25964 0.01323-0.52122 0.05176-0.7832 0.11914l-13.338 3.4297c-2.0958 0.53906-3.3496 2.66-2.8105 4.7559 0.53906 2.0958 2.66 3.3496 4.7559 2.8105l13.338-3.4297c2.0958-0.53906 3.3496-2.66 2.8105-4.7559-0.47168-1.8339-2.1552-3.0223-3.9727-2.9297zm-76.578 10.613-5.2559 1.3262c-3.7058 0.93431-5.9382 4.6692-5.0039 8.375l3.8789 15.383c0.93431 3.7058 4.6692 5.9382 8.375 5.0039l5.4473-1.373zm61.748 8.6328c-1.8151-0.13024-3.5217 1.022-4.0312 2.8457-0.58239 2.0842 0.62671 4.2321 2.7109 4.8145l13.262 3.7051c2.0842 0.58239 4.2321-0.62671 4.8145-2.7109 0.58239-2.0842-0.62671-4.2301-2.7109-4.8125l-13.264-3.707c-0.26053-0.0728-0.52194-0.11616-0.78125-0.13477zm-42.154 23.957c-0.02211 0.64755 0.08472 1.3133 0.34375 1.9629l5.3164 13.334c1.0109 2.535 3.8897 3.8256 6.4551 2.8945l3.7109-1.3477c2.5654-0.9311 3.8195-3.7208 2.8086-6.2559l-3.8047-9.541z"
            fill="currentColor"
          />
        </svg>
      </button>
      {/* Badge for unread announcements */}
      {newCount > 0 && (
        <span className="absolute top-0 right-0 bg-snow-red text-xs rounded-full px-1">
          {newCount}
        </span>
      )}
      {/* Dropdown */}
      {showAnnouncements && (
        <div className="absolute right-0 top-[100%] mt-2 w-[500px] bg-white text-black rounded shadow-lg z-50">
          <div className="max-h-64 overflow-y-auto font-normal">
            {announcements.map((a, idx) => (
              <div
                key={idx}
                className="p-4 border-b last:border-b-0 "
                style={{
                  display: "grid",
                  gridTemplateColumns: "100px 1fr",
                  gap: "15px",
                }}
              >
                <img src={a.image ?? ""} style={{ placeSelf: "center" }} />
                <div>
                  <div className="font-semibold">
                    {a.title || "Announcement"}
                  </div>
                  <div
                    className="text-sm font-normal"
                    dangerouslySetInnerHTML={{ __html: a.content }}
                  ></div>
                  {a.date && (
                    <div className="text-xs text-gray-500 mt-1">
                      {new Date(a.date).toLocaleDateString()}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
